import { Route, Redirect } from 'react-router-dom';
import { currentUser, Names } from 'Utils';

export const ProtectedRoute = ({ component: Component, ...rest }) => {
	const isLogin = currentUser.isLogin();
	return (
		<Route
			{...rest}
			render={(props) =>
				isLogin ? (
					<Component {...rest} {...props} />
				) : (
					<Redirect
						to={{
							pathname: Names.login.path,
							state: { from: props.location }
						}}
					/>
				)
			}
		/>
	);
};
